/**
 * dopamiles-mobile-sticky-atc.js
 * Shows/hides the fixed-bottom sticky ATC bar on mobile.
 *
 * Strategy:
 *   - IntersectionObserver watches the main desktop ATC button.
 *   - When the main button is NOT visible (scrolled past), show sticky bar.
 *   - CSS @media already hides the bar on desktop — JS only toggles visibility
 *     class for the mobile case.
 *   - "Add to cart" in sticky bar triggers submit on the main product form,
 *     so Dawn's cart AJAX handling fires normally.
 */

(function () {
  'use strict';

  const VISIBLE_CLASS = 'bnc-sticky-visible';

  function init() {
    const stickyBar = document.querySelector('[data-mobile-sticky-atc]');
    if (!stickyBar) return;

    const mainForm = document.querySelector('[data-bnc-product-form]');
    const mainAtcBtn = document.querySelector('[data-bnc-main-atc]');

    if (!mainAtcBtn || !mainForm) return;

    // Ornament bar: "Choose bundle" scrolls up to the Bundle & Save bars (the main button when
    // the page has none). The scroll-margin-top in CSS keeps the bars clear of the header.
    const bundleBtn = stickyBar.querySelector('[data-sticky-bundle-btn]');
    if (bundleBtn) {
      bundleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const dest = document.querySelector('[data-bnc-case-bars]') || mainAtcBtn;
        const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        dest.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
      });
    }

    // Wire sticky button to submit main form
    const stickyBtn = stickyBar.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        // Trigger click on the real ATC button so Dawn's product-form.js
        // handles loading state, cart drawer open, etc.
        mainAtcBtn.click();
      });
    }

    // IntersectionObserver: hide sticky when main ATC is in viewport
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyBar.classList.remove(VISIBLE_CLASS);
          } else {
            stickyBar.classList.add(VISIBLE_CLASS);
          }
        });
      },
      {
        // Trigger as soon as button fully exits viewport
        threshold: 0,
        rootMargin: '0px',
      }
    );

    observer.observe(mainAtcBtn);

    // Hide sticky bar when any input inside product form is focused
    // (avoids overlap with mobile keyboard)
    mainForm.querySelectorAll('input, select, textarea').forEach((input) => {
      input.addEventListener('focus', () => stickyBar.classList.remove(VISIBLE_CLASS));
      input.addEventListener('blur', () => {
        // Re-check visibility after blur by reading observer's last state
        // via a one-shot observe + unobserve trick
        const rect = mainAtcBtn.getBoundingClientRect();
        const inViewport = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (!inViewport) stickyBar.classList.add(VISIBLE_CLASS);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
